import {CHANGE_CHECKED_STATE} from "../../../../enums/Request/currentRequestControls.types";

export const changeCheckedStateInDropDownWith_checkbox = (element) => {
    return {
        type: CHANGE_CHECKED_STATE,
        payload: element,
    };
};
